import type { SearchValues } from "../types";

export const searchValues: SearchValues = {
  title: "",
  isPublished: "",
};

export const excelHeaderCellsName: Record<string, string> = {
  "المعرف": "id",
  "العنوان": "title",
  "حالة النشر": "isPublished",
};
